import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as t } from "../../../utils/rg-util/index3.js";
import { isDoubleDoor as l } from "../../queries/index3.js";
const f = (o, e) => t(o, r.Door, e).filter(l).length;
export {
  f as getLevelDoubleDoorsCount
};
//# sourceMappingURL=index14.js.map
